import {Typography} from "@mui/material"

function TextToHTML({text, ...props}: {text: string; [key: string]: any}) {
	const dangerousText = {__html: text.replace(/(?:\r\n|\r|\n)/g, "<br />")}
	return <Typography {...props} dangerouslySetInnerHTML={dangerousText} />
}

export {TextToHTML}
